import TripsFilter from "./tripsFilter/tripsFilter";
import TripsList from "./tripsList/tripsList";
import Pagination from "../../../shared/pagination/pagination";

import './allTrips.css';

const AllTrips = () => {
    return(
        <div className={'trips-section flex gap-0 align-top hr-space-between'}>
            <div className="page-filter-sec">
                <TripsFilter/>
            </div>
            <div className={'trips-table'}>
                <div className="margin-b-30">
                    <div className="search-box margin-b-30 drivers-search round-corner-8">
                        <input type="text" placeholder={'Search'}/>
                    </div>
                    <div className="sf-medium font-17">List View</div>
                </div>
                <div className="margin-b-50"><TripsList data={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}/></div>
                <div className=""><Pagination/></div>

            </div>
        </div>
    )
}

export default AllTrips;
